import { defineMessages } from 'react-intl-next';

const _default_1: {
    ok: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    gotIt: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    onboardingStep1Heading: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    onboardingStep1Description: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
    ok: {
        id: 'rovo-onboarding-ok',
        defaultMessage: 'OK',
        description: 'Action button for completing the rovo onboarding spotlight',
    },
    gotIt: {
        id: 'rovo-onboarding-got-it',
        defaultMessage: 'Got it',
        description: 'Action button for completing the rovo onboarding spotlight',
    },
    onboardingStep1Heading: {
        id: 'rovo-onboarding-step-1-heading',
        defaultMessage: 'Search across company apps',
        description: 'Spotlight onboarding step 1 heading',
    },
    onboardingStep1Description: {
        id: 'rovo-onboarding-step-1-description',
        defaultMessage: 'Choose an app to get more relevant results and filters. For example, filter by Space in Confluence.',
        description: 'Spotlight onboarding step 1 description',
    },
});
export default _default_1;
